import { render, staticRenderFns } from "./ChatRoomView.vue?vue&type=template&id=5b910805&scoped=true"
import script from "./ChatRoomView.vue?vue&type=script&lang=js"
export * from "./ChatRoomView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b910805",
  null
  
)

export default component.exports